<template>
    <div id="login">
        <div class="wrapper">
            <form class="login-form" @submit.prevent="login()">
                <header class="form-header">
                    <img src="@/assets/img/upmood_logo.svg" alt="Upmood" class="logo">

                    <p>Insight Login Portal</p>
                </header>

                <custom-input
                    :label="$t('username')"
                    v-model="email"
                    :required="true"
                    :auto-complete="true"
                    type="email"
                ></custom-input>

                <div class="password">
                    <custom-input
                        :label="$t('password')"
                        v-model="password"
                        :type="showPassword ? 'text' : 'password'"
                        :required="true"
                        :auto-complete="true"
                    >
                    </custom-input>

                    <span class="toggle" @click="showPassword = !showPassword">{{ showPassword ? $t('hide') : $t('show')}}</span>

                    <p class="error" v-if="error">{{ error[0] }}</p>
                </div>

                <button class="button--ok">
                    {{ loading ? $t('loading') : $t('login') }}
                </button>
            </form>
            <AppFooter/>
        </div>
    </div>
</template>

<script>
import CustomInput from '@/components/utils/CustomInput.vue'
import { mapFields } from 'vuex-map-fields'

export default {

	data () {
		return {
			showPassword: false
		}
	},

	computed: {
		...mapFields('auth', [
			'email',
			'password',
			'loading',
			'error'
		])
	},

	methods: {
		login () {
			if (!this.email || !this.password) return

			const form = new FormData()

			form.append('email', this.email)
			form.append('password', this.password)

			this.$store.dispatch('auth/login', form)
		}
	},

	components: {
		CustomInput
	}
}
</script>

<style lang="scss" scoped>
#login {
    display: flex;
    justify-content: center;
    align-items: center;
}

.wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 0.15rem;

    .app-footer {
        width: 420px;
        margin-bottom: 10px;
        font-size: 12px;
        text-align: center;
        font-weight: 600;
    }
}

.login-form {
    background-color: #fff;
    padding: 3rem 3rem 2rem 3rem;
    display: flex;
    flex-direction: column;
    min-width: 520px;

    .form-header {
        .logo {
            width: 7rem;
            margin: 0 auto;
            display: block;
        }
    }

    .error {
        color: #E71D36;
        margin-bottom: 2rem;
    }

    .password {
        position: relative;
        width: 100%;

        .toggle {
            font-size: 12px;
            cursor: pointer;
            position: absolute;
            right: 9px;
            top: 44px;
            text-transform: uppercase;
            color: #3A9BEF;
        }
    }

    button {
        margin: auto;
    }
}

p {
    text-align: center;
}

button {
    align-self: flex-end;
}
</style>
